import { Playlist } from "@/savaradio/common";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface IsLoading {
  get: boolean;
  create: boolean;
  delete: boolean;
  update: boolean;
}

interface PlaylistState {
  value?: Playlist[];
  caches: Record<string, Playlist[]>;
  isLoading: IsLoading;
}

const initialState: PlaylistState = {
  caches: {},
  isLoading: {
    get: false,
    create: false,
    delete: false,
    update: false
  },
};

const playlistSlice = createSlice({
  name: "playlist_slice",
  initialState,
  reducers: {
    reset: (state, action: PayloadAction<Playlist[] | undefined>) => {
      state.value = action.payload;
    },
    append: (state, action: PayloadAction<Playlist>) => {
      if (!state.value) state.value = [];
      const exists = state.value.some(item => item._id === action.payload._id);
      if (!exists) state.value.push(action.payload);
    },
    merge: (state, action: PayloadAction<Playlist>) => {
      if (!state.value) return;
      const index = state.value.findIndex(i => i._id === action.payload._id);
      if (index !== -1) state.value[index] = action.payload;
    },
    pop: (state, action: PayloadAction<Playlist>) => {
      if (state.value) {
        state.value = state.value.filter((item) => item._id !== action.payload._id);
      }
    },
    setLoading: (state, action: PayloadAction<Partial<IsLoading>>) => {
      state.isLoading = { ...state.isLoading, ...action.payload };
    },
    setCaches: (state, action: PayloadAction<{ search: string, result: Playlist[] }>) => {
      const { search, result } = action.payload;
      const existing = state.caches[search] || [];
      
      const map = new Map();
      [...existing, ...result].forEach(item => map.set(item._id, item));
      
      state.caches[search] = Array.from(map.values());
    },
    mergeCache: (state, action: PayloadAction<{ id: string, upd: Partial<Playlist> }>) => {
      const { id, upd } = action.payload;
      Object.keys(state.caches).forEach(key => {
        state.caches[key] = state.caches[key].map(item => 
          item._id === id ? { ...item, ...upd } : item
        );
      });
    }
  },
});

export const { reset, append, merge, pop, setLoading, setCaches, mergeCache } = playlistSlice.actions;
export const playlist_slice = playlistSlice.reducer;